import { useEffect, useState, useRef } from 'react'
import { Dropdown, MenuProps, Tooltip, Popconfirm } from 'antd'
import style from './index.module.scss'

import user_default from '../../static/image/user_default.png'
import { getImgUrlById, deepCopy } from '../../util'
import useStore from '../../store/useStore'
import { memosModule } from '../../modules/memos'
import { PlusCircleOutlined, LogoutOutlined } from '@ant-design/icons'
import { StorageModule } from '../../modules/storage'
import * as apis from "../../api/networkDisk";

interface Props {
    //是否显示姓名
    isShowName: any;
    isWap?: any,
    //限制显示个数
    limit?: any
    //navbar 刨除前几个
    excludeLimit?: any,
    data?: any,
    showTalkPop?: any,
    showRemove?: any,
    showNoExit?: any
    onRefresh?: () => void;

}
interface DataType {
    key: React.Key;
    name: string;
}

const ManList = (props: Props) => {
    const { store, dispatch } = useStore();
    const [userInfos, setUserInfos] = useState<any>([]);
    const [showPop, setShowPop] = useState<boolean>(false);
    const [userInfo, setUserInfo] = useState<any>(StorageModule.getUser().user);
    const [subjectInfo, setSubjectInfo] = useState<any>({});

    console.log('data', props.data)
    const operationMan = (users: any, type: any) => {
        console.log('operationMan', props.data, users, type, store.subjectInfo.data)
        if (props.data?.id != store.subjectInfo.subjectId) {
            getDetail(users, type)
        } else {
            memosModule.operationMan(users, type, store.subjectInfo.data)
        }
    }
    const getDetail = async (users: any, type: any) => {
        try {
         let res:any=  await apis.getExcellingTopic(props.data?.id)
         if (res.ok) {
            memosModule.operationMan(users, type, res.data)
                props.onRefresh && props.onRefresh()
            }
        } catch (e: any) {
            //console.log(e.code)
        }
    }
    let items: MenuProps['items'] = [
        {
            label: '从讨论组移除',
            key: 'item-1',
        },
    ];
    console.log(userInfo)
    if (props.showRemove === false || userInfo?.id != store.subjectInfo.data?.owner?.id) {
        items = []
    }
    /**
  * @name 重置
  */

    /**
     * @name 关闭退出登录弹出框
     */
    const onClick: MenuProps['onClick'] = ({ key, domEvent }) => {
        switch (key) {
            case 'item-1':
                operationMan(userInfos.id, 'delete')
                break;
        }
    };

    const MemoNodeHtml = (i: any) => {
        return (
            <>
                <Dropdown overlayClassName='better-z-index' menu={{ items, onClick, }} key={i.id} trigger={['contextMenu']}>
                    <div onMouseEnter={(e) => {
                        e.stopPropagation();
                        setUserInfos(i)
                    }} data-flex='main:left cross:center' >

                        {props.isShowName ? <><img alt="" className={`${style.user_default} ${store.onLine?.some((j: any) => j === i.id) ? 'online' : ''}`} style={{ flex: '0 0 30px' }} src={(i.avatar) ? getImgUrlById(i.avatar) : user_default} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                            <div className='sl-ellipsis'>{i.username}</div>
                        </> : <Tooltip title={i.username}>
                            <img alt="" className={`${style.user_default} ${store.onLine?.some((j: any) => j === i.id) ? 'online' : ''}`} style={{ flex: '0 0 30px' }} src={(i.avatar) ? getImgUrlById(i.avatar) : user_default} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                        </Tooltip>

                        }</div>

                </Dropdown>
            </>

        )
    }
    return (
        <div data-flex={`main:left cross:center ${props.isWap ? 'flex-wrap' : ''}`} >
            {
                props.data?.userInfos?.map((i: any, index: any) => (
                    <div key={index} className={`${props.isWap ? 'user-item' : ''}`}>
                        {props.excludeLimit ? <>
                            {
                                index > props.excludeLimit - 1 && MemoNodeHtml(i)
                            }
                        </> :
                            <>{index < (props.limit ? Number(props.limit) : props.data?.userInfos?.length) &&
                                MemoNodeHtml(i)}

                            </>}



                    </div>
                ))
            }
            {props.showTalkPop && <Dropdown trigger={['click']} dropdownRender={() => (
                <div className={style.down_content}>
                    {props.data?.userInfos?.map((i: any, id: any) => {
                        return MemoNodeHtml(i)
                    })}
                    <PlusCircleOutlined onClick={props.showTalkPop} className={style.add_icon} style={{ fontSize: '30px', color: '#ccc', margin: '5px', flex: '0 0 30px' }} />
                </div>

            )}>
                <div className={style.userInfos_item}>+<br />{store.subjectInfo.data?.userInfos?.length - 5 > 0 ? store.subjectInfo.data?.userInfos?.length - 5 : 0}</div>
            </Dropdown>
            }
            {/* props.showExit && StorageModule.getUser()?.user['id'] != store.subjectInfo.data?.owner?.id */}
            {!props.showNoExit&&props.data?.userInfos?.some((i: any) => StorageModule.getUser()?.user['id'] === i.id) && (StorageModule.getUser().user != store.subjectInfo.data?.owner?.id) && <Popconfirm placement="top" title={'确定退出讨论组?'} onConfirm={() => {
                operationMan(StorageModule.getUser()?.user['id'], 'delete')
            }} okText="确定" cancelText="取消">
                <LogoutOutlined className='icon_hover' />
            </Popconfirm>}
        </div >
    )
}

export default ManList